/**
 * Created by mauget on 1/4/16.
 */
// BaseVisualControlFactory.js

import BaseFactory from 'BaseFactory.js'
import sequenceService from 'SequenceService.js';
import factoryService   from 'FactoryService.js';
import themeService from 'ThemeService.js';
import listService from 'ListService';
import util from 'util/Util';

//=============================================================================
//
// This intermiediate base class is meant to be abstract. It holds property
// definitions cloned into model instances. Not all models use all the
// properties, but that's not an issue.  Add new properties here or in a
// child class. Be sure to _.clone( props ) before using them.
//
// -Lou Mauget, December 5, 2015
//
//=============================================================================
class BaseVisualControlFactory extends BaseFactory {

    //========================================================================
    // Called by child control's factory
    // Declare the base attributes, then override a subset
    //========================================================================
    createChildAttributes(  factoryKey, pos, isGroupChild = false ) {
        let factoryParams;
        
        // Retrieving the values given in the respective factories of the required view.
        if(factoryKey === 'workflow_page' || factoryKey === 'workflow_frame') {
            factoryParams = factoryService.workflowFactories[factoryKey];
        } else if (factoryKey === 'behaviors_page' || factoryKey === 'behaviors_frame' ) {
            factoryParams = factoryService.behaviorsFactories[factoryKey];
        } else {
            factoryParams = factoryService.factories[factoryKey];
        }
        
        if(factoryKey.startsWith('control')){
            factoryParams.name = factoryParams.name + ' ' + sequenceService.getControlNumber();
        }
        
        let nextTabIndex = 0;
            
        if (factoryKey !== 'page_instance' && factoryKey !== 'layout_frame' && !isGroupChild) {
            nextTabIndex = sequenceService.nextTabIndex();
        }
        const nextZIndex=sequenceService.nextZIndex();
        const defaultFont = listService.accountSettings.DefaultFontSelected || "verdana";

        // For formal definition of keys, see constants.
        // TODO Verify / use PF item names.
        return  {
            accessDesc: '',
            accessSilent: 'false',
            attrId: new Date().getTime(),
            backgroundColor:  '#FFFFFF',    // keep it empty to apply the theme for each control (really?)
            boldSelection: '',
            borderColor: '#333333',         // keep it empty to apply the theme for each control (really?)
            border: '',                     // keep it empty to apply the theme for each control
            caption: '',
            dpi: 72,
            encrypt: false,
            factoryKey: factoryKey,
            fontFamily: '',                // keep it empty to apply the theme for each control
            fontSize: '',                  // keep it empty to apply the theme for each control
            gridWidth: 20,
            gridHeight: 20,
            height:  factoryParams.height,
            defaultHeight: factoryParams.height,
            icon: factoryParams.icon,
            italicSelection: '',
            left: pos ? pos.left : 0,
            maxChars: 400,
            name: factoryParams.name,
            numericValue: 0,
            controlName: factoryParams.name,    // used for display
            padding: '0',
            rtl: 'false',
            pageColor: '#FFFFFF', // or #FFFF99
            shadow: 'true',
            silent: false,
            styleColorText: '#000000',      // keep it empty to apply the theme for each control (really?)
            transparency: '1',
            tabEnabled : true,
            tabIndex: nextTabIndex,
            text: '',
            textFont:  '',                  // keep it empty to apply the theme for each control
            textSize : '',
            textStyle: '',                  // keep it empty to apply the theme for each control
            textWeight: '',                 // keep it empty to apply the theme for each control
            titleFont: defaultFont + ', 10',
            toolTip : '',
            top: pos ? pos.top  : 0,
            width: factoryParams.width,
            zOrder: nextZIndex,
            originalZOrder:nextZIndex,
            isMandatory: false,
            obligatoryMessage: '',
            textAlignment: 'left',
            alignLeftSelection : 'lightgrey',
            alignCenterSelection : 'transparent',
            alignRightSelection : 'transparent',
            transparentBackground: 'false',
            id: sequenceService.nextDomId(),
            marginTop: '',
            marginBottom: ''
        };

    }

    resolveForInitialMinHeight(props){//PF-8701 The min height should be defined by the font size but should not be less that the lowest Height

        const myText = props.text;
        const myFont = themeService.resolveThemeFont('fontFamily', props.fontFamily) + ',' +
        themeService.resolveThemeFont('fontSize',  props.fontSize) + 'px,' +
        themeService.resolveThemeFont('textWeight', props.textWeight) + ',' +
        themeService.resolveThemeFont('textStyle',  props.textStyle);

        const minHeight = util.measureHeight(myText, myFont);

        if(minHeight > props.lowestHeight){
            props.minHeight = minHeight;
        }
        else{
            props.minHeight = props.lowestHeight;
        }

    }

    // Children overrdide this method
    createView( factoryKey, pos ) {
        throw 'BaseVisualControlFactory.createView( factoryKey, pos ) is an abstract method.';
    }

}

export default BaseVisualControlFactory;
